var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-624.000000, -822.000000)",
    fill: "#859599",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/linkedIn",
    transform: "translate(90.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51561662,18.1249973 L4.24609316,18.1249973 L4.24609316,7.61330363 L7.51561662,7.61330363 L7.51561662,18.1249973 Z M5.89843297,6.17190082 C5.38280902,6.17190082 4.93749794,5.98440144 4.56249866,5.60940216 C4.18749937,5.23440287 4,4.78909179 4,4.27346784 C4,3.75784389 4.18749937,3.31253281 4.56249866,2.93753353 C4.93749794,2.56253424 5.38280902,2.37503487 5.89843297,2.37503487 C6.41405692,2.37503487 6.859368,2.56253424 7.23436729,2.93753353 C7.60936657,3.31253281 7.79686595,3.75784389 7.79686595,4.27346784 C7.79686595,4.78909179 7.60936657,5.23440287 7.23436729,5.60940216 C6.859368,5.98440144 6.41405692,6.17190082 5.89843297,6.17190082 Z M19.7499624,18.1249973 L16.480439,18.1249973 L16.480439,12.9921971 C16.480439,12.1484491 16.4101267,11.5390757 16.269502,11.1640764 C16.0116903,10.5312654 15.5077849,10.2148599 14.7577869,10.2148599 C14.0077888,10.2148599 13.4804463,10.4961093 13.1757594,11.0586079 C12.9413848,11.4804819 12.8241977,12.1015744 12.8241977,12.9218847 L12.8241977,18.1249973 L9.58983042,18.1249973 L9.58983042,7.61330363 L12.7187292,7.61330363 L12.7187292,9.05470644 L12.7538854,9.05470644 C12.98826,8.58595774 13.3632587,8.19923991 13.8788827,7.89455296 C14.4413814,7.51955367 15.09763,7.3320543 15.847628,7.3320543 C17.3710617,7.3320543 18.4374658,7.81252208 19.0468391,8.77345711 C19.5155878,9.54689277 19.7499624,10.7422024 19.7499624,12.3593861 L19.7499624,18.1249973 Z",
    id: "\\uF0E1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7832d023.svg";
export { ForwardRef as ReactComponent };